import React, { memo } from "react";
import { Table } from "antd";
import {
  VehicleType,
  VehicleTypeMap,
  VehicleSize,
  VehicleSizeMap,
  STATUS,
} from "../../utils/enums";
import TableWrapper from "./components/TableWrapper";
import { useConfig } from "../../config-context";
import Loading from "../Loading";

const columns = [
  {
    title: "Make",
    dataIndex: "make",
    key: "make",
  },
  {
    title: "Model",
    dataIndex: "model",
    key: "model",
  },
  {
    title: "Vehicle Type",
    dataIndex: "vehicleType",
    key: "vehicleType",
    render: text => {
      return (
        <span>{VehicleTypeMap[text] ?? VehicleTypeMap[VehicleType.Other]}</span>
      );
    },
  },
];

const postedColumns = configLang => [
  {
    dataIndex: "vehicle",
    key: "vehicle",
    render: (_, vehicle) => {
      const title = `${vehicle.isLateModel ? "Late Model" : vehicle.year} ${
        VehicleSizeMap[vehicle.size]
      } ${VehicleTypeMap[vehicle.displayVehicleType]}`;

      const obfuscatedDescription = `(Ex: ${
        configLang?.CoreService[
          `Enum:SizeVehicleType:${vehicle.size}:DisplayVehicleType:${vehicle?.displayVehicleType}:Tooltip`
        ]
      })`;

      const description =
        vehicle.size === VehicleSize.UNKNOWN ||
        obfuscatedDescription.includes("Size information unavailable")
          ? null
          : obfuscatedDescription;

      return (
        <section style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <span>{title}</span>
          <span>{description}</span>
        </section>
      );
    },
  },
];

export default memo(function VehicleTable({ data, isPosted = false }) {
  const { configLang, status } = useConfig();

  if (status === STATUS.LOADING) {
    return <Loading />;
  }

  console.log("configLang", configLang);

  return (
    <TableWrapper title="Vehicles">
      <Table
        style={{
          marginBottom: 32,
        }}
        pagination={false}
        dataSource={data}
        columns={isPosted ? postedColumns(configLang) : columns}
        rowKey="vehicleId"
        showHeader={isPosted ? false : true} // hide header for posted table
      />
    </TableWrapper>
  );
});
